var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAutumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.713867,
    y: 0.713867,
    width: 23.3155,
    height: 23.3156,
    rx: 3,
    fill: "#BD9154"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.1416 0H4.85787C3.56992 0.00144251 2.33514 0.513718 1.42443 1.42444C0.513712 2.33515 0.00143994 3.56994 0 4.85789V20.1421C0.00143994 21.4301 0.513712 22.6648 1.42443 23.5756C2.33514 24.4863 3.56992 24.9986 4.85787 25H20.1416C21.4296 24.9986 22.6645 24.4863 23.5753 23.5756C24.4861 22.6649 24.9985 21.4301 25 20.1421V4.85789C24.9985 3.56988 24.4861 2.33509 23.5753 1.42438C22.6645 0.513668 21.4296 0.0014166 20.1416 0ZM23.057 20.1421C23.0561 20.915 22.7486 21.6559 22.202 22.2024C21.6555 22.7489 20.9145 23.0562 20.1416 23.057H4.85787C4.08507 23.0561 3.3442 22.7487 2.79775 22.2022C2.2513 21.6558 1.94389 20.9149 1.94296 20.1421V4.85789C1.94389 4.08509 2.2513 3.34421 2.79775 2.79776C3.3442 2.2513 4.08507 1.9439 4.85787 1.94296H20.1416C20.9145 1.94379 21.6555 2.25115 22.202 2.79761C22.7486 3.34407 23.0561 4.08501 23.057 4.85789V20.1421Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.88977 8.2429C6.07453 11.0586 5.49006 14.0461 7.21328 16.4129L5.1803 18.4458C5.04757 18.5829 4.95781 18.7557 4.92209 18.9431C4.88636 19.1305 4.90623 19.3243 4.97924 19.5005C5.05224 19.6768 5.17521 19.8278 5.33299 19.9351C5.49076 20.0423 5.67647 20.1011 5.86722 20.1041C5.99481 20.1043 6.12118 20.0792 6.23905 20.0304C6.35692 19.9815 6.46397 19.9099 6.55405 19.8195L8.58963 17.7839C11.3809 19.6851 14.2352 18.6023 16.7565 16.1096C24.4197 8.51872 18.0077 -0.195763 8.88977 8.2429ZM18.0667 10.3414C17.3179 13.239 13.3349 18.2234 9.99905 16.3747L14.1129 12.2607C14.2892 12.0773 14.3865 11.8321 14.3839 11.5778C14.3814 11.3235 14.2793 11.0803 14.0994 10.9004C13.9195 10.7206 13.6763 10.6184 13.422 10.6159C13.1677 10.6134 12.9225 10.7108 12.7391 10.887L8.62467 15.0015C5.6516 9.92604 19.8204 2.11349 18.0667 10.3414Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAutumn);
export default __webpack_public_path__ + "static/media/autumn.7e73eb1c2db60c3a441dd955677d9db0.svg";
export { ForwardRef as ReactComponent };